import React from "react";

export type SecurityShieldProps = {
  /**
   * Width of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  width?: number;
  /**
   * Height of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  height?: number;
  /**
   * The size of the logo
   * small: 122*46 | medium: 155*60 | large: 217*83
   * @default medium
   */
  size?: "small" | "medium" | "large";
};

const sizes = {
  small: {
    width: 41,
    height: 34,
  },
  medium: {
    width: 35,
    height: 36,
  },
  large: {
    width: 41,
    height: 34,
  },
};

export const SecurityShield = React.forwardRef<
  SVGSVGElement,
  SecurityShieldProps
>((props, ref) => {
  const { size = "medium", width, height } = props;
  const svgSize = width && height ? { width, height } : sizes[size];
  return (
    <svg
      ref={ref}
      width={svgSize.width}
      height={svgSize.height}
      viewBox="0 0 35 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33464 17.9231L16.3346 23.7564L25.668 12.0897M17.5013 1.58972L1.16797 10.9231V12.6028C1.16797 22.6576 7.8334 31.4941 17.5013 34.2564C27.1692 31.4941 33.8346 22.6576 33.8346 12.6028V10.9231L17.5013 1.58972Z"
        stroke="#1D1929"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
});

SecurityShield.displayName = "SecurityShield";
